import { useMutation, useQuery, useQueryClient } from 'react-query';

import { approveAdminDeviceIntakeTrap } from 'api/traps/AdminDeviceIntake/approveAdminDeviceIntakeTrap';
import { getAdminDeviceIntake } from 'api/traps/AdminDeviceIntake/getAdminDeviceIntake';
import { moveAdminDeviceIntakeDevices } from 'api/traps/AdminDeviceIntake/moveAdminDeviceIntakeDevices';
import { rejectAdminDeviceIntakeTrap } from 'api/traps/AdminDeviceIntake/rejectAdminDeviceIntakeTrap';
import { assignIntakeToken, createIntakeDevice, getIntakeTokenDevices } from 'api/traps/AdminDeviceIntake/manageIntake';

export const ADMIN_DEVICE_INTAKE_QUERY_KEY = 'AdminDeviceIntake';

export const useAdminDeviceIntake = (search = '') =>
  useQuery([ADMIN_DEVICE_INTAKE_QUERY_KEY, search], () => getAdminDeviceIntake(search), {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

export const useCreateIntakeDevice = () => {
  const queryClient = useQueryClient();
  return useMutation(createIntakeDevice, {
    onSuccess: () => {
      queryClient.invalidateQueries(ADMIN_DEVICE_INTAKE_QUERY_KEY);
      queryClient.invalidateQueries('IntakeTokenDevices');
    },
  });
};

export const useAssignIntakeToken = () => {
  const queryClient = useQueryClient();
  return useMutation(assignIntakeToken, {
    onSuccess: () => {
      queryClient.invalidateQueries(ADMIN_DEVICE_INTAKE_QUERY_KEY);
      queryClient.invalidateQueries('IntakeTokenDevices');
    },
  });
};

export const useIntakeTokenDevices = (token: string) =>
  useQuery(['IntakeTokenDevices', token], () => getIntakeTokenDevices(token), { enabled: !!token });

export const useApproveAdminDeviceIntakeTrap = () => {
  const queryClient = useQueryClient();

  return useMutation(approveAdminDeviceIntakeTrap, {
    onSuccess: () => queryClient.invalidateQueries(ADMIN_DEVICE_INTAKE_QUERY_KEY),
  });
};

export const useRejectAdminDeviceIntakeTrap = () => {
  const queryClient = useQueryClient();

  return useMutation(rejectAdminDeviceIntakeTrap, {
    onSuccess: () => queryClient.invalidateQueries(ADMIN_DEVICE_INTAKE_QUERY_KEY),
  });
};

export const useMoveAdminDeviceIntakeDevices = () => {
  const queryClient = useQueryClient();

  return useMutation(moveAdminDeviceIntakeDevices, {
    onSuccess: () => queryClient.invalidateQueries(ADMIN_DEVICE_INTAKE_QUERY_KEY),
  });
};
